import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import actions from 'actions'
import MetaList from 'components/MetaList/MetaList'
import MetaEditForm from 'components/MetaEditForm/MetaEditForm'
import MetaAddForm from 'components/MetaAddForm/MetaAddForm'
import { Grid } from 'semantic-ui-react'
import css from './MetaEditContainer.module.sass'

class MetaEditContainer extends Component {
  render () {
    const {
      addItem,
      updateItem,
      removeItem,
      setActiveItem,
      updateMeta
    } = this.props
    const {
      meta,
      player: { playerElement }
    } = this.props.media

    return (
      <Grid className={css.wrapper}>
        <Grid.Row className={css.row}>
          <Grid.Column className={css.list} width='6'>
            <MetaList
              data={meta.editData}
              activeItem={meta.activeItem}
              playerElement={playerElement}
              setActiveItem={setActiveItem}
              removeItem={removeItem}
              updateMeta={updateMeta}
            />
            <div className={css.controls}>
              <MetaAddForm addItem={addItem} currentDts={this.props.media.player.dts} />
            </div>
          </Grid.Column>
          <Grid.Column width='10'>
            <MetaEditForm
              data={meta.editData}
              activeItem={meta.activeItem}
              playerElement={playerElement}
              addItem={addItem}
              updateItem={updateItem}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

const {
  object,
  func
} = PropTypes

MetaEditContainer.propTypes = {
  media: object.isRequired,
  addItem: func.isRequired,
  updateItem: func.isRequired,
  removeItem: func.isRequired,
  setActiveItem: func.isRequired,
  updateMeta: func.isRequired
}

export default connect((state) => {
  return {
    media: state.media
  }
}, {
  addItem: actions.media.addItem,
  updateItem: actions.media.updateItem,
  removeItem: actions.media.removeItem,
  setActiveItem: actions.media.setActiveItem,
  updateMeta: actions.media.updateMeta
})(MetaEditContainer)



// WEBPACK FOOTER //
// ./src/containers/MetaEditContainer/MetaEditContainer.js